const styles = theme => ({
  container: {
    paddingTop: 0,
    paddingBottom: 0
  },
  form: {
    marginBottom: theme.spacing(10.5)
  },
  root: {
    width: "100%",
    boxShadow: "none",
    borderRadius: 0,
    background: "#fff"
  },
  media: {
    position: "relative",
    margin: "0 auto",
    height: "auto",
    width: "500px",
    [theme.breakpoints.down("md")]: {
      width: "100%"
    }
  },
  previewImage: {
    position: "relative"
  },
  locationControl: {
    margin: 0
  },
  locationLabel: {
    visibility: "hidden",
    position: "absolute",
    "& + .MuiInput-formControl": {
      marginTop: 0
    }
  },
  label: {
    color: theme.palette.primary.default,
    fontWeight: 700
  },
  location: {
    margin: 0,
    // marginTop: theme.spacing(-2),
    padding: `${theme.spacing(3)}px 0`,
    width: "100%",
    border: "none",
    fontSize: 20,
    fontWeight: 700,
    outline: "none"
  },
  locationSuggestionContainer: {
    position: "absolute",
    marginTop: theme.spacing(-2),
    // padding: theme.spacing(1),
    width: "100%",
    background: "#fff",
    boxShadow: `4px 3px 3px rgba(0, 0, 0, .3)`,
    zIndex: 5
  },
  grayLine: {
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    },
    [theme.breakpoints.up("sm")]: {
      width: "65%",
      margin: "0 auto"
    },
    borderBottom: "1px solid #f1f1f1"
  },
  locationSuggestion: {
    padding: `${theme.spacing(1)}px`,
    borderBottom: `1px solid rgba(0, 0, 0, 0.2)`,
    "&:last-of-type": {
      borderBottom: "none"
    }
  },
  locationSuggestionActive: {
    background: "#f1f1f1"
  },
  locationHelper: {
    position: "absolute",
    bottom: theme.spacing(1)
  },
  descriptionControl: {
    marginBottom: 0
  },
  sendIconContainer: {
    marginRight: theme.spacing(2)
  },

  buttonsContainer: {
    marginTop: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      "@supports (margin-top: constant(safe-area-inset-bottom))": {
        "--safe-area-inset-bottom": "constant(safe-area-inset-bottom)",

        marginTop: "max(12px, constant(safe-area-inset-bottom))"
      },
      "@supports (margin-top: env(safe-area-inset-bottom))": {
        "--safe-area-inset-bottom": "env(safe-area-inset-bottom)",
        marginTop: "max(12px, env(safe-area-inset-bottom))"
      }
    }
  },
  submitButton: {
    backgroundColor: theme.palette.primary.default,
    "&:hover": {
      backgroundColor: theme.palette.primary.default
    }
  },
  cancelButton: {
    color: [theme.palette.primary.default, "!important"],
    width: "81px",
    marginRight: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      marginRight: theme.spacing(2)
    }
  },
  textArea: {
    background: "#f1f1f1",
    fontSize: 12,
    "&> textarea": {
      padding: theme.spacing(1.5)
    }
  }
  // splitButtons: {
  //   position: "relative",
  //   paddingTop: theme.spacing(),
  //   "&> button": {
  //     padding: 0,
  //     border: 0,
  //     textTransform: "none"
  //   },
  //   "&> button:hover": {
  //     border: "none"
  //   },
  //   "&> button:nth-of-type(1)": {
  //     justifyContent: "row",
  //     alignItems: "flex-start",
  //     background: "transparent",
  //     color: theme.palette.primary.default + "!important",
  //     opacity: 0.3,
  //     fontSize: 32
  //   },
  //   "&> button:nth-of-type(2)": {
  //     justifyContent: "flex-end",
  //     background: "transparent",
  //     color: theme.palette.primary.default + "!important",
  //     fontSize: 32
  //   }
  // },
  // sendIcon: {
  //   marginLeft: theme.spacing(1.5),
  //   fontSize: 32,
  //   color: theme.palette.primary.light
  // }
})

export default styles



// WEBPACK FOOTER //
// ./src/pages/App/CreatePost/styles.js